import React from "react"
import styled, { keyframes } from "styled-components"

import classNames from "classnames"
import { colors } from "utils/styled-constants"

const rotate = keyframes`
  0% {
    transform: translate3d(-50%, -50%, 0) rotate(0deg);
  }
  100% {
    transform: translate3d(-50%, -50%, 0) rotate(360deg);
  }
`

const StyledSpinner = styled.div`
  &.hidden {
    display: none;
  }
  position: relative;
  &::before {
    animation: 1s cubic-bezier(0.15, 0.46, 0.85, 0.54) infinite ${rotate};
    border: solid 3px transparent;
    border-bottom-color: ${props => props.color || colors.darkBlue};
    border-radius: 50%;
    content: "";
    height: 40px;
    left: 50%;
    opacity: inherit;
    position: absolute;
    top: 50%;
    transform: translate3d(-50%, -50%, 0);
    transform-origin: center;
    width: 40px;
    will-change: transform;
  }
`

const LoadingSpinner = ({ display, color }) => {
  return (
    <StyledSpinner color={color} className={classNames({ hidden: !display })} />
  )
}

LoadingSpinner.defaultProps = {
  display: true,
}

export default LoadingSpinner
